import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ApiResponse } from '../../models/api';
import { CommonMethods } from '../../common-methods';
import { UiService } from '../../ui.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {
  isForgotPasswordMode = false;

  constructor(
    private authService: AuthService,
    private uiService: UiService,
    private _tosterService: ToastrService,
    private _router: Router
  ) { }

  /**
   * Declaring form name and control names
   */
  authForm = new FormGroup<any>({});

  ngOnInit(): void {
    this.authForm.addControl('email_id', new FormControl('', [Validators.required, Validators.email]));
    this.authForm.addControl('password', new FormControl('', [Validators.required]));
  }

  login() {
    if (this.authForm.valid) {
      const data: any = {
        email_id: this.authForm.value.email_id,
        password: this.authForm.value.password
      }

      this.authService.login(data).subscribe({
        next: (res: any) => {
          if (res) {
            let authToken = res.payload.original.access_token;
            let decrypted_token: string = atob(authToken.split('.')[1]);
            if (!decrypted_token) {
              this._tosterService.error("Invalid token. Please try again.");
            } else {
              let tokenObj = JSON.parse(decrypted_token);
              CommonMethods.setItem("token", authToken)
              CommonMethods.setItem("auth", true);
              CommonMethods.setItem("userId", tokenObj.id)
              CommonMethods.setItem("role", tokenObj.role_code)
              if ("COMPANY" === tokenObj.role_code) {
                CommonMethods.setItem("companyId", tokenObj.id);
                CommonMethods.setItem('CompanyName', tokenObj.name)
              } else if ("ADMIN" === tokenObj.role_code) {
                CommonMethods.setItem("adminId", tokenObj.id)
              } else{
                CommonMethods.setItem("companyId", tokenObj.company_id)
                CommonMethods.setItem("serviceCenterId", tokenObj.id)
              }

              // CommonMethods.setItem("role", tokenObj.auth['authority']);
              this.uiService.loginValid.next(true);
              this._router.navigate(["dashboard"]);
              window.location.reload()
              // Show the toast
              this._tosterService.success("Welcome back! Logged in securely!");
            }
          } else {
            console.error(res);
          }
        },
        error: (err: any) => {
          console.error(err);
          this._tosterService.error("Oh no!. Your login attempt was unsuccessful.");
        }
      })
    }
  }

  forgetPassword() {
    if (this.authForm.get('email_id')?.valid) {
      const data = { email_id: this.authForm.value.email_id };

      this.authService.forgotPassword(data).subscribe({
        next: () => {
          this._tosterService.success("Reset password link sent to your email.");
          this.isForgotPasswordMode = false;
          this.authForm.addControl('password', new FormControl('', [Validators.required]));
          this.authForm.get('password')?.setValue('');
        },
        error: () => {
          this._tosterService.error("Failed to send reset password email.");
        }
      });
    }
  }

  toggleMode() {
    this.isForgotPasswordMode = !this.isForgotPasswordMode;
    if (this.isForgotPasswordMode) {
      this.authForm.removeControl('password');
    } else {
      this.authForm.addControl('password', new FormControl('', [Validators.required]));
    }
  }
}